import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var HourglassIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M5 23a1 1 0 01-.117-1.993L5 21h.999L6 18c0-2.397 1.397-4.726 3.187-6C7.397 10.726 6 8.397 6 6l-.001-3H5a1 1 0 01-.117-1.993L5 1h14a1 1 0 01.117 1.993L19 3h-1.001L18 6c0 2.397-1.397 4.726-3.187 6C16.603 13.274 18 15.603 18 18l-.001 3H19a1 1 0 01.117 1.993L19 23H5zm6.999-10C10.261 12.998 8 15.486 8 18l-.001 3h8L16 18c0-2.514-2.26-5.002-3.999-5h-.002zm4-10h-8L8 6c0 2.51 2.254 4.994 3.991 5h.01c1.688.002 3.87-2.346 3.994-4.785L16 6l-.001-3z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
HourglassIcon.isCarinaIcon = true;
export default HourglassIcon;
